import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-227cbf86"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "group-header"
};
const _hoisted_2 = {
  class: "header-content"
};
const _hoisted_3 = {
  class: "position-tips"
};

const _hoisted_4 = /*#__PURE__*/_createTextVNode("您所在的位置： ");

const _hoisted_5 = {
  key: 0,
  href: "/teachCenter.html?menuType=teachingRoom"
};
const _hoisted_6 = ["href"];
const _hoisted_7 = {
  key: 0,
  class: "group-info"
};
const _hoisted_8 = {
  class: "group-title"
};
const _hoisted_9 = {
  class: "info-list"
};
const _hoisted_10 = {
  class: "info-item text-overflow"
};

const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "所属类别：", -1));

const _hoisted_12 = {
  key: 0,
  class: "info-item text-overflow"
};
const _hoisted_13 = ["title"];
const _hoisted_14 = {
  key: 1,
  class: "info-item text-overflow"
};
const _hoisted_15 = ["title"];
const _hoisted_16 = {
  key: 2,
  class: "info-item text-overflow"
};
const _hoisted_17 = ["title"];
const _hoisted_18 = {
  key: 3,
  class: "info-item text-overflow"
};
const _hoisted_19 = ["title"];
import { getUrlParams } from '@/plugins/utils';
import { ArrowRight } from '@element-plus/icons-vue';
export default {
  props: {
    menu: Object,
    groupInfo: Object
  },

  setup(__props) {
    const props = __props;
    const source = getUrlParams('source');
    const name = getUrlParams('name');
    return (_ctx, _cache) => {
      const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item");

      const _component_el_breadcrumb = _resolveComponent("el-breadcrumb");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createVNode(_component_el_breadcrumb, {
        "separator-icon": _unref(ArrowRight)
      }, {
        default: _withCtx(() => [_createVNode(_component_el_breadcrumb_item, null, {
          default: _withCtx(() => [_unref(source) === 'teachCenter' ? (_openBlock(), _createElementBlock("a", _hoisted_5, _toDisplayString(_unref(name)), 1)) : (_openBlock(), _createElementBlock("a", {
            key: 1,
            href: `/courseGroupList.html?menuId=${__props.menu.menu_id}&name=${__props.menu.nav_name}`
          }, _toDisplayString(__props.menu.nav_name), 9, _hoisted_6))]),
          _: 1
        }), _createVNode(_component_el_breadcrumb_item, null, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(source) === 'teachCenter' ? '教研室详情' : '详情'), 1)]),
          _: 1
        })]),
        _: 1
      }, 8, ["separator-icon"])]), __props.groupInfo ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, _toDisplayString(__props.groupInfo.groupName), 1), _createElementVNode("ul", _hoisted_9, [_createElementVNode("li", _hoisted_10, [_hoisted_11, _createElementVNode("span", null, _toDisplayString(__props.groupInfo.majorName), 1)]), __props.groupInfo.roleName1 && __props.groupInfo.userNames1 ? (_openBlock(), _createElementBlock("li", _hoisted_12, [_createElementVNode("span", null, _toDisplayString(__props.groupInfo.roleName1) + "：", 1), _createElementVNode("span", {
        title: __props.groupInfo.userNames1
      }, _toDisplayString(__props.groupInfo.userNames1), 9, _hoisted_13)])) : _createCommentVNode("", true), __props.groupInfo.roleName2 && __props.groupInfo.userNames2 ? (_openBlock(), _createElementBlock("li", _hoisted_14, [_createElementVNode("span", null, _toDisplayString(__props.groupInfo.roleName2) + "：", 1), _createElementVNode("span", {
        title: __props.groupInfo.userNames2
      }, _toDisplayString(__props.groupInfo.userNames2), 9, _hoisted_15)])) : _createCommentVNode("", true), __props.groupInfo.roleName3 && __props.groupInfo.userNames3 ? (_openBlock(), _createElementBlock("li", _hoisted_16, [_createElementVNode("span", null, _toDisplayString(__props.groupInfo.roleName3) + "：", 1), _createElementVNode("span", {
        title: __props.groupInfo.userNames3
      }, _toDisplayString(__props.groupInfo.userNames3), 9, _hoisted_17)])) : _createCommentVNode("", true), __props.groupInfo.roleName4 && __props.groupInfo.userNames4 ? (_openBlock(), _createElementBlock("li", _hoisted_18, [_createElementVNode("span", null, _toDisplayString(__props.groupInfo.roleName4) + "：", 1), _createElementVNode("span", {
        title: __props.groupInfo.userNames4
      }, _toDisplayString(__props.groupInfo.userNames4), 9, _hoisted_19)])) : _createCommentVNode("", true)])])) : _createCommentVNode("", true)])]);
    };
  }

};